import styled from 'styled-components';

export const Wrapper = styled.div`
  flex: 1;
  position: relative;
  margin-bottom: 30px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 20px;
  min-height: 470px;

  img {
    width: 320px;
    height: 320px;
  }
`;

export const Left = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
`;

export const Right = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
`;
